var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoDetectionSvg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 78,
    viewBox: "0 0 81 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3214 9.64416H28.5168V0.131836H0.634033V27.2743H10.3211L10.3214 9.64416Z",
    fill: "#5CA6B3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3211 50.7269H0.634033V77.8694H28.5168V68.3571H10.3214L10.3211 50.7269Z",
    fill: "#5CA6B3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9718 68.3571H52.7764V77.8694H80.6591V50.7269H70.9721L70.9718 68.3571Z",
    fill: "#5CA6B3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7764 0.131836V9.64416H70.9718V27.2745H80.6588V0.131982L52.7764 0.131836Z",
    fill: "#5CA6B3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9874 23.5841L35.6751 44.3305L24.3027 33.2606L17.3955 39.9844L35.6751 57.6968L63.8949 30.3082L56.9874 23.5841Z",
    fill: "#5CA6B3"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDetectionSvg);
export default __webpack_public_path__ + "static/media/logo_detection_svg.33a0e89e2ce212d1e19e55ace733a79c.svg";
export { ForwardRef as ReactComponent };